import React from 'react';
import { Box, Chip, MenuItem, TextField } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { Lang, ProjectInterface } from '../types';
import { languages, PROJECT_LIST } from '../constants';

interface ProjectLanguageSelectorProps {
    selectedProject: ProjectInterface;
    onProjectChange: (project: ProjectInterface) => void;
    lang: Lang;
    onLangChange: (lang: Lang) => void;
    isStarted: boolean;
}

export const ProjectLanguageSelector: React.FC<ProjectLanguageSelectorProps> = ({
    selectedProject,
    onProjectChange,
    lang,
    onLangChange,
    isStarted,
}) => {
    return (
        <>
            <TextField
                key="Language"
                select
                size="small"
                label="Language"
                onChange={({ target }) => {
                    onLangChange(target.value as Lang);
                }}
                value={lang}
                disabled={isStarted}
            >
                {languages.map((langOption) => (
                    <MenuItem key={langOption} value={langOption}>
                        {langOption.toUpperCase()}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                key="Project"
                select
                style={{ width: '300px' }}
                label="Project"
                size="small"
                onChange={({ target }) => {
                    const p = PROJECT_LIST.find((p) => p.label === target.value) || PROJECT_LIST[0];
                    onProjectChange(p);
                }}
                value={selectedProject.label}
            >
                {PROJECT_LIST.map((project) => (
                    <MenuItem key={project.label} value={project.label}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <div>
                                {project.isProtected && (
                                    <Lock
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            color: 'gray',
                                            display: 'block',
                                        }}
                                    />
                                )}
                            </div>
                            <div>{project.label}</div>
                            {project.isRealtime && <Chip size="small" label="Realtime" color="primary" />}
                        </Box>
                    </MenuItem>
                ))}
            </TextField>
        </>
    );
};
